import {
  Dispatch,
  FunctionComponent,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import BasicModal from "@components/core/modals/BasicModal";
import { useTranslation } from "react-i18next";
import { Select, Spin } from "antd";
import BasicLink from "@components/core/links/BasicLink";
import { OfficeModels } from "@type/core/models/models.types";

const { Option } = Select;

type ModelOptions = {
  id: string;
  name: string;
  isSubtitle: boolean;
};

interface ChangeModelMailModalProps {
  visible: boolean;
  onCancel: () => void;
  onSubmit: (id?: string) => void;
  setIsMailContentVisible: Dispatch<SetStateAction<boolean>>;
  className?: string;
  modelsList: OfficeModels[];
}

const ChangeModelMailModal: FunctionComponent<ChangeModelMailModalProps> = ({
  visible,
  onCancel,
  onSubmit,
  setIsMailContentVisible,
  className = "",
  modelsList,
}) => {
  const { t } = useTranslation();

  const [modelMailId, setModelMailId] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const options: ModelOptions[] = [];

  modelsList.forEach((currentModels) => {
    if (currentModels.models.length) {
      options.push({
        id: currentModels.id,
        name: currentModels.name,
        isSubtitle: true,
      });
      currentModels.models.forEach((model) => {
        options.push({
          id: model.id,
          name: model.name,
          isSubtitle: false,
        });
      });
    }
  });
  const showSelect = options.length > 0;
  const defaultValue =
    (options.length > 0 && options.find((option) => !option.isSubtitle)?.id) ||
    "";

  useEffect(() => {
    if (options && !modelMailId) {
      const firstModel = options.find((option) => option.isSubtitle === false);
      if (firstModel) {
        setModelMailId(firstModel.id);
      }
    }
  }, [options, modelMailId]);

  return (
    <BasicModal
      visible={visible}
      onCancel={onCancel}
      onOk={() => {
        setIsLoading(true);
        onSubmit(modelMailId);
        setIsLoading(false);
        onCancel();
        setIsMailContentVisible(true);
      }}
      buttonText={t("buttons.validate")}
      title={t("offices.mailModel.modal.title")}
      closable={false}
      className={`app-modal-change-model ${className}`}
    >
      <>
        {isLoading ? (
          <div className="h-100 flex-grow-1 d-flex align-items-center justify-content-center">
            <Spin />
          </div>
        ) : showSelect ? (
          <Select
            className="w-100"
            value={modelMailId ? modelMailId : defaultValue}
            onChange={(value: string) => setModelMailId(value)}
          >
            {options.map((option) => {
              if (option.isSubtitle) {
                return (
                  <Option
                    key={"office_" + option.id}
                    className="font-weight-bold"
                    disabled
                  >
                    {option.name}
                  </Option>
                );
              } else {
                return (
                  <Option key={"model_" + option.id} value={option.id}>
                    &nbsp;&nbsp;{option.name}
                  </Option>
                );
              }
            })}
          </Select>
        ) : (
          <div>
            <p className="text-center">
              {t("offices.mailModel.modal.noModel")}
            </p>
            <p className="text-center">
              {t("offices.mailModel.modal.redirection")}
              <BasicLink
                to=""
                onClick={(e) => {
                  e.preventDefault();
                  window.open("./model-mail", "_blank");
                }}
              >
                {t("offices.mailModel.modal.mailModels")}
              </BasicLink>
            </p>
          </div>
        )}
      </>
    </BasicModal>
  );
};

export default ChangeModelMailModal;
